class DownloadService {
  downloadBlob(blob: Blob, filename: string = 'Docteller.csv'): void {
    if (!blob || !(blob instanceof Blob)) {
      throw new Error('Invalid blob data');
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Nettoyer le DOM
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}

export const downloadService = new DownloadService();
